import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { c as n, a as i } from "../../../../index-CROKJrb5.js";
import { c as x, f } from "../../../../create-component-CBAeEoQ6.js";
import { TextCardTitle as p } from "../TextCardTitle/index.js";
import { useTextCardStateAtoms as d } from "../TextCardState/index.js";
import { u as C } from "../../../../react-B_GApDuV.js";
const g = n({
  base: "cur-flex cur-grow cur-flex-col cur-gap-2 cur-w-full",
  variants: {
    size: {
      sm: "cur-p-4",
      md: "cur-p-7",
      lg: "cur-p-7"
    }
  }
}), A = x(
  "TextCardContent",
  f(
    ({ as: e, children: s, className: o, title: c = null, ...t }, a) => {
      const u = e || "div", { sizeAtom: l } = d(), m = C(l);
      return /* @__PURE__ */ r.jsx(
        u,
        {
          className: i("cur-flex cur-grow cur-flex-col cur-gap-2", o),
          ref: a,
          ...t,
          children: /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-w-full cur-grow cur-flex-col cur-items-start cur-gap-2", children: /* @__PURE__ */ r.jsxs("div", { className: g({ size: m }), children: [
            typeof c == "string" ? /* @__PURE__ */ r.jsx(p, { children: c }) : c,
            s ? /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-flex-col cur-gap-2", children: s }) : null
          ] }) })
        }
      );
    }
  )
);
export {
  A as TextCardContent
};
//# sourceMappingURL=index.js.map
